import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import useCancelSubscription from "../queries/use-cancel-subscription"
import useBugSnag from "@/app/hooks/useBugSnag"

interface CancelSubscriptionModalProps {
  open: boolean
  onClose: () => void
  userId: string
}

export default function CancelSubscriptionModal({
  open,
  onClose,
  userId,
}: CancelSubscriptionModalProps) {
  const { mutateAsync: cancelSubscription, isPending } = useCancelSubscription()
  const { notify } = useBugSnag()

  const handleCancelSubscription = async () => {
    try {
      await cancelSubscription(userId)
      onClose()
    } catch (error) {
      notify(error)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]" withClose={!isPending}>
        <DialogHeader>
          <DialogTitle>¿Estás seguro de que querés desuscribir a este alumno?</DialogTitle>
          <DialogDescription className="font-semibold text-black/85">
            Una vez desuscripto, el alumno perderá el acceso premium y solo podrá recuperarlo si él
            mismo vuelve a activar su suscripción.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button size="sm" variant="outline" onClick={onClose} disabled={isPending}>
            Cancelar
          </Button>
          <Button size="sm" onClick={handleCancelSubscription} disabled={isPending}>
            Confirmar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
